import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";

export const Route = createFileRoute("/$")({
  head: () => buildRouteHead("/$", { noIndex: true }),
  beforeLoad: ({ location }) => {
    if (location.pathname === "/en/thank-you-contact") {
      throw redirect({ to: "/en/thank-you/contact", replace: true });
    }
  },
  component: NotFound,
});
